"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');
var _videoCall = require('web/services/videoCall');

var _useClassState = require('web/screens/VideoCall/useClassState');

// Setup passes VideoRoomSession.publishProblem; the settings modal passes its
// own handler (or nothing). Either receives the StreamManager rejection.


// The preview stream of the three setup containers (AudioSetupGroup,
// VideoSetupGroup, MobileCameraSetup), which were the same class code:
// - mount: a StreamManager for the one device kind, then `update()`;
// - the device id changed (componentDidUpdate): `update({ <kind>DeviceId })`;
// - unmount: `stop()`.
// A resolved stream is stored with a class-style setState, so every
// resolution re-renders, as before. A rejection goes to the problem handler
// the container had when the call was made, like `this.props`.
 const useSetupStream = (
  kind,
  deviceId,
  onUserProblemPublish,
) => {
  const [{ stream }, setState] = _useClassState.useClassState({ stream: null })
  const streamManager = _react.useRef(null)

  const latestProblemHandler = _react.useRef.call(void 0, onUserProblemPublish)
  _react.useLayoutEffect.call(void 0, () => { latestProblemHandler.current = onUserProblemPublish })

  _react.useLayoutEffect.call(void 0, () => {
    const updateStream = (s) => setState({ stream: s })
    const onProblem = latestProblemHandler.current

    if (!streamManager.current) {
      streamManager.current = kind === 'mic'
        ? new (0, _videoCall.StreamManager)({ micDeviceId: deviceId, useMic: true })
        : new (0, _videoCall.StreamManager)({ camDeviceId: deviceId, useCam: true })
      streamManager.current.update()
        .then(updateStream)
        .catch(onProblem)
      return
    }

    streamManager.current
      .update(kind === 'mic' ? { micDeviceId: deviceId } : { camDeviceId: deviceId })
      .then(updateStream)
      .catch(onProblem)
  }, [kind, deviceId, setState])

  _react.useLayoutEffect.call(void 0, () => () => { _optionalChain([streamManager, 'access', _ => _.current, 'optionalAccess', _2 => _2.stop, 'call', _3 => _3()]) }, [])

  return stream
}; exports.useSetupStream = useSetupStream
